import type { RootState } from "store";
import { ErrorProducts } from "./root.types";

export const selectOptions = (state: RootState) => state.root.options;

export const selectErrorProducts = (state: RootState) => state.root.errorProducts;

export const selectPalletFitErrorByCargoId =
  (cargoId: string) =>
  (state: RootState): ErrorProducts | undefined =>
    state.root.errorProducts.find((error) => error?.data?.attributes?.uid === cargoId);
